var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHashtagBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.481,
    height: 37.5,
    viewBox: "0 0 37.481 37.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hashtag-bold",
    transform: "translate(-3.769 -3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10529",
    "data-name": "Path 10529",
    d: "M14.644,3.75H30.356c6.825,0,10.894,4.069,10.894,10.894V30.337c0,6.844-4.069,10.913-10.894,10.913H14.663c-6.825,0-10.894-4.069-10.894-10.894V14.644C3.75,7.819,7.819,3.75,14.644,3.75Z",
    fill: "#fd792f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10530",
    "data-name": "Path 10530",
    d: "M9.712,19.838a1.369,1.369,0,0,1,0-2.738h6.769l-.731-6.562a1.377,1.377,0,1,1,2.737-.3l.769,6.862h5.306l-.731-6.562a1.377,1.377,0,1,1,2.738-.3l.75,6.862h6.619a1.369,1.369,0,0,1,0,2.738H27.619l.6,5.344h7.069a1.369,1.369,0,0,1,0,2.738H28.519l.731,6.563A1.383,1.383,0,0,1,28.031,36h-.15a1.393,1.393,0,0,1-1.369-1.219l-.769-6.862H20.419l.731,6.563A1.383,1.383,0,0,1,19.931,36h-.15a1.393,1.393,0,0,1-1.369-1.219l-.769-6.862H11.025a1.369,1.369,0,0,1,0-2.738h6.319l-.6-5.344Zm10.425,5.325h5.325l-.6-5.344H19.538Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtagBold);
export default __webpack_public_path__ + "static/media/hashtag-bold.1a49bcafdc8d0b31969c961eb27dcaad.svg";
export { ForwardRef as ReactComponent };